
import React from 'react'
import './M_Header.css'

export const M_Header = ({ element, color, backgroundColor, notsticky }) => {

    notsticky = notsticky ? false : true
    color = color ? color : 'var(--color-grey)'
    backgroundColor = backgroundColor ? backgroundColor : 'var(--color-white)'
    return (
        <div
            className='headerComponent'
            style={notsticky ? {
                background: backgroundColor,
                borderBottom: `1px solid ${color} `,
                zIndex: '110',
                position: 'sticky',
                padding:'2px 0px'
            } : {
                background: backgroundColor,
                borderBottom: `1px solid ${color} `
            }}>
            {element}
        </div >

    )
}

